import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { ScrollText, Lightbulb } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1654099602420-c90791787b79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzZXJlbmUlMjBsYWtlJTIwcmVzb3J0JTIwbmF0dXJlfGVufDB8fHx8MTc3ODk0MDYyNHww&ixlib=rb-4.1.0&q=85";

export default function Rules() {
  const { t, lang } = useLang();
  const [content, setContent] = useState({ rules_en: "", rules_hu: "", advices_en: "", advices_hu: "" });

  useEffect(() => {
    api.get("/rules").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  const rules = lang === "hu" ? content.rules_hu : content.rules_en;
  const advice = lang === "hu" ? content.advices_hu : content.advices_en;

  return (
    <div data-testid="rules-page">
      <section className="relative h-[40vh] min-h-[300px] overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative container-deg h-full flex flex-col justify-end pb-16 text-bg-paper">
          <div className="overline text-bg-paper/80">04 · {t("nav.rules")}</div>
          <h1 className="font-serif text-5xl md:text-6xl mt-3 text-balance text-bg-paper">{t("rules.heading")}</h1>
          <p className="mt-4 text-bg-paper/85 max-w-2xl">{t("rules.sub")}</p>
        </div>
      </section>

      <section className="py-20 md:py-28 container-deg grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div className="card-deg p-8 md:p-10" data-testid="rules-block">
          <div className="flex items-center gap-3 mb-6">
            <ScrollText size={20} strokeWidth={1.5} className="text-accent" />
            <h2 className="font-serif text-3xl">{t("rules.rules")}</h2>
          </div>
          <pre className="whitespace-pre-wrap font-sans text-ink-soft leading-relaxed text-[15px]">{rules || "—"}</pre>
        </div>
        <div className="card-deg p-8 md:p-10" data-testid="advice-block">
          <div className="flex items-center gap-3 mb-6">
            <Lightbulb size={20} strokeWidth={1.5} className="text-accent" />
            <h2 className="font-serif text-3xl">{t("rules.advice")}</h2>
          </div>
          <pre className="whitespace-pre-wrap font-sans text-ink-soft leading-relaxed text-[15px]">{advice || "—"}</pre>
        </div>
      </section>
    </div>
  );
}
